import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";

const PullNextChapterIndicator = ({
  isPulling = false,
  pullProgress = 0,
  isReadyToAdvance = false,
  hasNext = false,
  nextChapter = null,
  nextChapterSubtitle = "",
  edition,
}) => {
  if (!isPulling && pullProgress <= 0.05) {
    return null;
  }

  const ui = edition?.ui || {};
  const nextTitle = nextChapter ? nextChapter.title.replace(/^#\s*/, "") : "";

  let label = "";
  if (!hasNext) {
    label = ui.pullNextBibleEnd || "全本圣经已读完 🎉";
  } else if (isReadyToAdvance) {
    label = ui.pullNextRelease
      ? ui.pullNextRelease(nextTitle, nextChapterSubtitle)
      : `松手进入下一章：${nextTitle}${nextChapterSubtitle ? ` · ${nextChapterSubtitle}` : ""}`;
  } else {
    label = ui.pullNextHint
      ? ui.pullNextHint(nextTitle, nextChapterSubtitle)
      : `继续上拉进入下一章：${nextTitle}${nextChapterSubtitle ? ` · ${nextChapterSubtitle}` : ""}`;
  }

  return (
    <Box
      data-testid="pull-next-chapter-indicator"
      sx={{
        mt: 1,
        mb: 2,
        p: 1.5,
        borderRadius: 2.5,
        border: "1px dashed",
        borderColor: isReadyToAdvance ? "primary.main" : "divider",
        bgcolor: (t) =>
          t.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.03)"
            : "rgba(0, 0, 0, 0.02)",
        textAlign: "center",
        transition: "border-color 140ms ease, transform 140ms ease",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          color: isReadyToAdvance ? "primary.main" : "text.secondary",
        }}
      >
        {hasNext && (
          <KeyboardDoubleArrowUpIcon
            fontSize="small"
            sx={{
              transform: isReadyToAdvance ? "rotate(180deg)" : "none",
              transition: "transform 160ms ease",
            }}
          />
        )}
        <Typography
          variant="caption"
          sx={{ fontWeight: isReadyToAdvance ? 800 : 600, fontSize: "0.8rem" }}
        >
          {label}
        </Typography>
      </Box>
      {hasNext && (
        <LinearProgress
          variant="determinate"
          value={Math.round(Math.min(1, pullProgress) * 100)}
          sx={{
            mt: 1,
            height: 4,
            borderRadius: 999,
            maxWidth: 240,
            mx: "auto",
          }}
        />
      )}
    </Box>
  );
};

export default PullNextChapterIndicator;
